import { lazy } from "react";
import Loadable from "app/components/Loadable";
import LoanType from "./LoanType";

const loantype = Loadable(lazy(() => import("./LoanType")));

const loantypeRoute = [{ path: "/loantype", element: <LoanType /> }];
export default loantypeRoute;
